import React from "react";
import InternalDb from "../../CommonJobBoards/InternalDb";
import CareerBuilder from "../../CommonJobBoards/CareerBuilder";
import Monster from "../../CommonJobBoards/Monster";
import KultSearch from "../../CommonJobBoards/KultSearch";
import IntegratedSearch from "../../CommonJobBoards/IntegratedSearch";
import { NewTab, PageTab, PageTabAdv } from "../../../../components";
import { useDispatch } from "react-redux";
import { resetIntegratedSearch } from "../../../../redux/slices/internalDbES/internalDbESlice";

const JobBoards = () => {
  const dispatch = useDispatch();
  const jobBoardMenus = [
    {
      title: "Internal DB",
      page: <InternalDb />,
      type: "main",
      id: "jobs_jobboards_internaldb",
    },
    {
      title: "Career Builder",
      page: <CareerBuilder />,
      type: "main",
      id: "jobs_jobboards_careerbuilder",
    },
    {
      title: "Monster",
      page: <Monster />,
      type: "main",
      id: "jobs_jobboards_monster",
    },
    // {
    //   title: "Kult Search",
    //   page: <KultSearch />,
    //   type: "main",
    //   id: "jobs_jobboards_kultsearch",
    // },
    {
      title: "Integrated Search",
      page: <IntegratedSearch />,
      type: "main",
      id: "jobs_jobboards_integratedsearch",
    },
  ];
  const handleChange = (selectedTab) => {
    // console.log("Selected tab:", selectedTab);
    dispatch(resetIntegratedSearch());
  };
  return (
    <div className="flex-1 flex flex-col overflow-hidden my-3">
      <NewTab
        tabs={jobBoardMenus}
        color="gray"
        variant="text"
        activeVariant="text"
        mode="url"
        tabId="job-boards"
        onTabChange={handleChange}
      />
    </div>
  );
};

export default JobBoards;
